import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_443: DocMigration = {
  maxSchemaVersion: "0.0.443",
  description: "Rename the group property 'isReadOnly' to 'isDeletable'",
  apply(json: any) {
    for (const groupKey in json.groups) {
      const group = json.groups[groupKey];
      if (group.isReadOnly) {
        group.isDeletable = true;
        delete group.isReadOnly;
      }
    }
    return json;
  },
};

export default migration_0_0_443;
